import { zodResolver } from '@hookform/resolvers/zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { ContactHit } from '../../components/SimpleContactSearch/Context';
import { useAuth } from '../../context/AuthProvider';
import {
  getCustomerDefaultsFromRequest,
  getSharedAirlineDefaultsFromRequest,
  SharedEmailOverrides,
  SharedEmailValidationSchema,
} from '../../utils/email';
import { Request } from '../../utils/types';

export type QuoteUpdateValues = SharedEmailOverrides & {
  isLongEmail: boolean;
  recipients: ContactHit[];
};

const validationSchema = z.object({
  ...SharedEmailValidationSchema,
  isLongEmail: z.boolean(),
  recipients: z.array(z.object({ id: z.number() })),
});

export const useCustomerQuoteUpdateForm = (request?: Request) => {
  const { user } = useAuth();
  const defaultValues = useMemo(() => {
    return {
      ...getSharedAirlineDefaultsFromRequest(request),
      ...getCustomerDefaultsFromRequest(request),
      isLongEmail: false,
      senderContactId: user?.contact_id,
    };
  }, [request, user?.contact_id]);

  const methods = useForm<z.infer<typeof validationSchema>>({
    mode: 'onSubmit',
    resolver: zodResolver(validationSchema),
    defaultValues,
  });

  return { methods };
};
